import { setCognitoToken, initTokenReadyPromise } from "./cognitoTokenStore";

const checkIsPhqIframe = () => {
  if (location.ancestorOrigins instanceof DOMStringList) {
    return Array.from(location.ancestorOrigins).some(origin =>
      origin.includes("gracehill.com")
    );
  }

  if (location.href.includes("isPhq=true")) {
    return true;
  }

  return false;
};

export const getPhqSubdomain = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("phqSubdomain") || "";
};

export const isIframed = window.self !== window.top && checkIsPhqIframe();

export const isIframeAdmin = (user, iframeAdminRoles) =>
  isIframed &&
  user.included?.some(
    item =>
      item.type === "role" && iframeAdminRoles.includes(item.attributes.name)
  );

const isGracehillOrigin = origin =>
  /^https:\/\/([a-zA-Z0-9-]+\.)*gracehill\.com$/.test(origin) &&
  !origin.includes("..") &&
  origin.length < 100;

const handleCognitoTokenMessage = event => {
  if (!isGracehillOrigin(event.origin)) return;
  if (event.data?.type === "COGNITO_TOKEN" && event.data?.token) {
    setCognitoToken(event.data.token);
  }
};

if (isIframed) {
  initTokenReadyPromise();
  window.addEventListener("message", handleCognitoTokenMessage);
}
